module.exports = __webpack_public_path__ + "static/media/Howard, Burlingame, CA5.484252ad.jpg";